export class InputHandler {
  constructor(dialElement, onFrequencyChange) {
    this.dial = dialElement;
    this.container = dialElement.parentElement;
    this.onFrequencyChange = onFrequencyChange;
    this.minFreq = 200;  // Narrower, more audible range
    this.maxFreq = 600;
    this.currentFreq = 400; // Start in middle

    this.setupMouseControl();
    this.setupKeyboardControl();
    this.setupTouchControl();
    this.setupWheelControl();

    // Initialize dial position
    this.updateFrequency(0.5); // Start at 50% (middle)
  }

  // Mouse control (vertical Y position)
  setupMouseControl() {
    const dialSection = document.getElementById('dial-section');

    const handleMouseMove = (e) => {
      const rect = dialSection.getBoundingClientRect();
      const y = e.clientY - rect.top;
      const normalized = 1 - (y / rect.height); // Invert: top = high freq, bottom = low freq
      const clamped = Math.max(0, Math.min(1, normalized));

      this.updateFrequency(clamped);
    };

    dialSection.addEventListener('mousemove', handleMouseMove);
    dialSection.addEventListener('mouseenter', handleMouseMove);
  }

  // Keyboard control (arrows, WASD)
  setupKeyboardControl() {
    document.addEventListener('keydown', (e) => {
      const speed = e.shiftKey ? 2 : 5; // Shift for fine control
      let changed = false;

      if (e.key === 'ArrowUp' || e.key === 'w' || e.key === 'W') {
        this.currentFreq = Math.min(this.maxFreq, this.currentFreq + speed);
        changed = true;
      }
      if (e.key === 'ArrowDown' || e.key === 's' || e.key === 'S') {
        this.currentFreq = Math.max(this.minFreq, this.currentFreq - speed);
        changed = true;
      }

      if (changed) {
        e.preventDefault();
        const normalized = (this.currentFreq - this.minFreq) / (this.maxFreq - this.minFreq);
        this.updateFrequency(normalized);
      }
    });
  }

  // Touch control (mobile - vertical swipe)
  setupTouchControl() {
    const dialSection = document.getElementById('dial-section');

    const handleTouch = (e) => {
      e.preventDefault();
      const touch = e.touches[0];
      const rect = dialSection.getBoundingClientRect();
      const y = touch.clientY - rect.top;
      const normalized = 1 - (y / rect.height); // Invert: top = high, bottom = low
      const clamped = Math.max(0, Math.min(1, normalized));

      this.updateFrequency(clamped);
    };

    dialSection.addEventListener('touchstart', handleTouch);
    dialSection.addEventListener('touchmove', handleTouch);
  }

  // Mouse wheel control
  setupWheelControl() {
    const dialSection = document.getElementById('dial-section');

    dialSection.addEventListener('wheel', (e) => {
      e.preventDefault();
      const delta = e.deltaY > 0 ? -5 : 5;
      this.currentFreq = Math.max(this.minFreq, Math.min(this.maxFreq, this.currentFreq + delta));
      const normalized = (this.currentFreq - this.minFreq) / (this.maxFreq - this.minFreq);
      this.updateFrequency(normalized);
    });
  }

  updateFrequency(normalized) {
    this.currentFreq = this.minFreq + (normalized * (this.maxFreq - this.minFreq));
    this.onFrequencyChange(this.currentFreq);
    this.updateDialVisual(normalized);
  }

  updateDialVisual(normalized) {
    // Rotate dial indicator from -135° (bottom) to +135° (top) = 270° range
    const angle = (normalized * 270) - 135;
    this.dial.style.transform = `rotate(${angle}deg)`;
  }
}
